import { SystemStyleObject } from '@chakra-ui/react';
import {
  getTypographyToken,
  ColorMode,
  getBoxSizingStyles,
} from '@allergan-data-labs/alle-elements-core';

export const getActionMenuAccordionButtonStyles = (
  colorMode: ColorMode
): SystemStyleObject => {
  return {
    ...getBoxSizingStyles(),
    cursor: 'pointer',
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    py: '4',
    px: '8',
    minHeight: '32',
    justifyContent: 'space-between',
    color: `${colorMode}.Text/Neutral/Default`,
    background: `${colorMode}.Container/Neutral/Transparent interactive/Enable`,
    ...getTypographyToken('Body/Small/Regular'),
    borderRadius: 'Small',
    _hover: {
      background: `${colorMode}.Container/Neutral/Transparent interactive/Hover`,
    },
    _active: {
      background: `${colorMode}.Container/Neutral/Transparent interactive/Pressed`,
    },
    _focusVisible: {
      background: `${colorMode}.Container/Neutral/Transparent interactive/Hover`,
      outlineColor: `${colorMode}.Border/Brand/Focus ring/Default`,
      outlineStyle: 'solid',
      outlineWidth: '4px',
    },
    _disabled: {
      cursor: 'not-allowed',
      color: `${colorMode}.Text/Neutral/Disabled/Default`,
      _hover: {
        background: `${colorMode}.Container/Neutral/Transparent interactive/Enable`,
      },
      _active: {
        background: `${colorMode}.Container/Neutral/Transparent interactive/Enable`,
      },
    },
  };
};

export const getActionMenuAccordionIconStyles = (
  isOpen: boolean
): SystemStyleObject => {
  const styles: SystemStyleObject = {
    transition: 'transform 0.2s',
    transformOrigin: 'center',
  };

  if (isOpen) {
    styles.transform = 'rotate(-180deg)';
  }

  return styles;
};

export const getActionMenuAccordionPanelStyles = (): SystemStyleObject => {
  return {
    padding: '8',
  };
};
